export default function ({ app, query, isDev, store }) {
  app.i18n.onLanguageSwitched = (oldLocale, newLocale) => {
    store.dispatch('getVersionAndLang', { query, isDev });
    store.dispatch('layout/getLayoutStory');
  };
}
